import React, { useMemo } from 'react';
import Loading from '../../../../Components/Loading';
import { useLaboratoryRequestsQuery } from '../../../../graphql/graphql';
import { SelectionListItemScheme } from '../../../Base/Components/SelectionList/SelectionListItem';
import SelectionList from '../../../Base/Components/SelectionList/SelectionList';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	laboratoryId: string;
	onClick: (id: string) => void;
}

const LaboratoryRequestList: React.FC<Props> = ({ laboratoryId, onClick }) => {
	const { data, isLoading } = useLaboratoryRequestsQuery({
		where: { laboratoryId },
	});

	const onItemClick = (item: SelectionListItemScheme) => {
		onClick(item.id);
	};

	const finalData: SelectionListItemScheme[] = useMemo(() => {
		const tempData: SelectionListItemScheme[] = [];
		data?.laboratoryRequisitions?.data?.forEach(item => {
			if (item?.id && item?.name && item.allowed) {
				tempData.push({
					id: item.id,
					name: item.name,
				});
			}
		});
		return tempData;
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	if (finalData.length < 1) {
		return <Text tx='component.laboratoryRequestList.noRequestsEnabled' />;
	}

	return (
		<SelectionList
			data={finalData}
			onItemClick={onItemClick}
			buttonLabel='component.laboratoryList.create'
		/>
	);
};

export default LaboratoryRequestList;
